// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"22deda66","510":"b1fe85e1","724":"a587bfaf","900":"a4b7331a"}[chunkId] + ".chunk.js";
};